import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiCrm from './vendors/farlo-ui-crm';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar';
import FarloUiMastheadCarousel from './vendors/farlo-ui-masthead-carousel';
import FarloUiRevolverFlickityCarousel from './vendors/farlo-ui-revolver-flickity-carousel.js';

((document, window, history) => {
	const pushState = history.pushState;

	// default navicon
	function navicon() {
		document
			.querySelector('.site-navigation__navicon')
			.addEventListener('click', (e) => {
				e.preventDefault();
				e.currentTarget.classList.toggle(
					'site-navigation__navicon--active'
				);
				document
					.querySelector('.site-navigation')
					.classList.toggle('site-navigation--active');
				document.body.classList.toggle('site-navigation--open');
			});
	}

	function getTallestSubMenu() {
		const submenus = document.querySelectorAll(
			'.site-navigation__sub-menu'
		);
		let tallest = null;
		let maxHeight = 0;

		submenus.forEach((submenu) => {
			// Get the current height of the submenu
			const height = submenu.offsetHeight;

			// Check if the current height is greater than the maxHeight found so far
			if (height > maxHeight) {
				maxHeight = height;
				tallest = submenu;
			}
		});

		// Return the tallest submenu
		return tallest;
	}

	function frontPagePopup() {
		const popup = document.querySelector('.frontpage__popup');
		const popupInner = document.querySelector('.frontpage__popup-inner');
		const closeButton = document.querySelector('.frontpage__popup-button');
		const popupCookieName = 'frontpagePopupSeen';

		// Show the popup
		function showPopup() {
			popup.style.display = 'flex';
		}

		// Hide the popup
		function hidePopup() {
			popup.style.display = 'none';
			setCookie(popupCookieName, 'true', 30); // Set cookie for 30 days
		}

		// Set a cookie
		function setCookie(name, value, days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			const expires = 'expires=' + date.toUTCString();
			document.cookie = name + '=' + value + ';' + expires + ';path=/';
		}

		// Get a cookie
		function getCookie(name) {
			const nameEQ = name + '=';
			const ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === ' ') {
					c = c.substring(1, c.length);
				}
				if (c.indexOf(nameEQ) === 0) {
					return c.substring(nameEQ.length, c.length);
				}
			}
			return null;
		}

		// Add event listener for the close button
		closeButton.addEventListener('click', function () {
			hidePopup();
		});

		// Hide the popup if click outside of popupInner
		popup.addEventListener('click', function (event) {
			if (!popupInner.contains(event.target)) {
				hidePopup();
			}
		});

		// Show the popup if cookie is not set
		if (!getCookie(popupCookieName)) {
			showPopup();
		}
	}

	// default navigation subnav
	function navigation(submenu) {
		if (
			'ontouchstart' in window ||
			navigator.maxTouchPoints > 0 ||
			navigator.msMaxTouchPoints > 0
		) {
			window._farlo.helpers
				.getSiblings(submenu)[0]
				.addEventListener('click', (e) => {
					if (
						!e.target.classList.contains(
							'site-navigation__menu-item--active'
						)
					) {
						e.preventDefault();

						e.currentTarget.classList.add(
							'site-navigation__menu-item--active'
						);
						submenu.classList.add(
							'site-navigation__sub-menu--active'
						);

						for (
							let i = 0;
							i <
							window._farlo.helpers.getSiblings(
								e.currentTarget.parentNode
							).length;
							i += 1
						) {
							if (
								window._farlo.helpers.getSiblings(
									e.currentTarget.parentNode
								)[i].children[0] &&
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[i].children[0].classList.contains(
										'site-navigation__menu-item--active'
									)
							) {
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[i].children[0].classList.remove(
										'site-navigation__menu-item--active'
									);
							}

							if (
								window._farlo.helpers.getSiblings(
									e.currentTarget.parentNode
								)[i].children[1] &&
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[i].children[1].classList.contains(
										'site-navigation__sub-menu--active'
									)
							) {
								window._farlo.helpers
									.getSiblings(e.currentTarget.parentNode)
									[i].children[1].classList.remove(
										'site-navigation__sub-menu--active'
									);
							}
						}
					} else {
						return true;
					}
				});
		} else {
			submenu
				.closest('.site-navigation')
				.addEventListener('mouseover', (e) => {
					if (
						submenu.parentNode.querySelector(
							'.site-navigation__sub-menu--active'
						)
					) {
						submenu.parentNode
							.querySelectorAll(
								'.site-navigation__sub-menu--active'
							)
							.forEach((_sel) => {
								_sel.classList.remove(
									'site-navigation__sub-menu--active'
								);
								_sel.parentNode.classList.remove(
									'site-navigation__menu-item--active'
								);
							});
					}
					submenu.classList.add('site-navigation__sub-menu--active');
					submenu.parentNode.classList.add(
						'site-navigation__menu-item--active'
					);

					if (e.currentTarget) {
						e.currentTarget
							.closest('.site-header')
							.removeAttribute('style');

						if (getTallestSubMenu()) {
							e.currentTarget
								.closest('.site-header')
								.setAttribute(
									'style',
									'min-height: calc(var(--header-height) + ' +
										getTallestSubMenu().offsetHeight +
										'px'
								);
						}
					}
				});

			submenu
				.closest('.site-navigation')
				.addEventListener('mouseout', (e) => {
					submenu.classList.remove(
						'site-navigation__sub-menu--active'
					);
					submenu.parentNode.classList.remove(
						'site-navigation__menu-item--active'
					);
					if (e.currentTarget) {
						e.currentTarget
							.closest('.site-header')
							.removeAttribute('style');
					}
				});
		}
	}

	function farloUiCrmSignup(_sel) {
		let farloUiSignupForm = null;

		if (typeof _sel.target !== 'undefined' && _sel.target !== null) {
			if (_sel.target.dataset.crmButtonFor !== '') {
				farloUiSignupForm = new FarloUiCrm(
					_sel.target.dataset.crmButtonFor
				);
			}
		} else if (farloUiSignupForm) {
			farloUiSignupForm.toggleForm();
		} else {
			farloUiSignupForm = new FarloUiCrm(_sel.id);
		}
	}

	function mastheadHeight() {
		  function adjustFullHeightBlocks() {
			document.querySelectorAll('.site-masthead--full-height').forEach(block => {
			  block.style.height = 'auto';
		
			  const contentHeight = block.scrollHeight;
			  const windowHeight  = window.innerHeight;
			  const newHeight     = Math.max(contentHeight, windowHeight);
		
			  block.style.height = newHeight + 'px';
			});
		  }
		
		  window.addEventListener('load',   adjustFullHeightBlocks);
		  window.addEventListener('resize', adjustFullHeightBlocks);
		
		  document.querySelectorAll('.site-masthead--full-height img')
			.forEach(img => {
			  if (!img.complete) {
				img.addEventListener('load', adjustFullHeightBlocks);
			  }
			});
	}


	function faqs() {
		const accordions = document.querySelectorAll(
			'.site-faqs__accordion-faq'
		);

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector(
				'.site-faqs__accordion-answer'
			);
			accordion.classList.add('site-faqs__accordion-faq--active');
			answer.style.maxHeight = answer.scrollHeight + 'px';
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector(
				'.site-faqs__accordion-answer'
			);
			accordion.classList.remove('site-faqs__accordion-faq--active');
			answer.style.maxHeight = null;
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector(
				'.site-faqs__accordion-question'
			);
			const answer = accordion.querySelector(
				'.site-faqs__accordion-answer'
			);

			question.onclick = () => {
				if (answer.style.maxHeight) {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			};
		});
	}

	function embedOverlay() {
		// Function to handle '.wp-block-embed'
		const videoContainers = document.querySelectorAll('.wp-block-embed');
	
		videoContainers.forEach((videoContainer) => {
			// Create overlay element
			const overlay = document.createElement('div');
			overlay.classList.add('wp-block-embed__overlay');
			overlay.onclick = function() {
				overlay.style.display = 'none';
				const video = videoContainer.querySelector('iframe');
				video.src += '&autoplay=1';
			};
	
			// Append overlay to video container
			videoContainer.appendChild(overlay);
		});
	
		// Function to handle '.farlo-ui-video'
		const farloVideoContainers = document.querySelectorAll('.farlo-ui-video');
	
		farloVideoContainers.forEach((container) => {
			const iframe = container.querySelector('iframe');
	
			if (iframe && iframe.dataset.src) {
				iframe.src = iframe.dataset.src;
			}
		});
	}
	

	function smoothScroll(_sel) {
		_sel.addEventListener('click', function (e) {
			e.preventDefault();

			if (
				e.target.classList.contains('leaflet-control-zoom-in') ||
				e.target.classList.contains('leaflet-control-zoom-out')
			) {
				return;
			}

			if (
				e.target.href.split('#')[1] !== 'explore-more' &&
				document.querySelector('.site-navigation__navicon--active') &&
				document.body.classList.contains('site-navigation--open')
			) {
				document.querySelector('.site-navigation__navicon').click();
			}

			if (e.target.parentNode.parentNode) {
				e.target.parentNode.parentNode.classList.remove(
					'site-navigation__sub-menu--active'
				);
			}

			if (e.target.parentNode.parentNode.parentNode) {
				e.target.parentNode.parentNode.parentNode
					.querySelector('a')
					.classList.remove('site-navigation__menu-item--active');
			}

			if (
				e.target.href.includes('#') &&
				document.getElementById(e.target.href.split('#')[1])
			) {
				document
					.getElementById(e.target.href.split('#')[1])
					.scrollIntoView({ behavior: 'smooth' });
			} else {
				window.location.href = e.target.href;
			}
		});
	}

	function elementInView(_sel) {
		const observer = new IntersectionObserver(function (entries) {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add(
						'site-farlo-ui-animated--has-animated'
					);
				}
			});
		});

		observer.observe(_sel);
	}

	function formLabels(_sel) {
		if (_sel) {
			_sel.closest('.gfield')
				.querySelector('.gform-field-label')
				.classList.add('screen-reader-text');
		}
	}

	function formSubmitButtons(_sel) {
		const submitButtonWrapper = document.createElement('div');

		_farlo.helpers.wrapElement(
			_sel.querySelector('input[type="submit"]'),
			submitButtonWrapper,
			'site-form-submit__button'
		);
	}

	history.pushState = function (state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document
				.querySelectorAll('.site-navigation__sub-menu')
				.forEach((_sel) => {
					navigation(_sel);
				});
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.site-farlo-ui-animated')) {
			document
				.querySelectorAll('.site-farlo-ui-animated')
				.forEach((_sel) => {
					elementInView(_sel);
				});
		}

		if (document.querySelector('.frontpage__popup')) {
			frontPagePopup();
		}

		if (document.querySelector('.site-masthead--full-height')){
			mastheadHeight();
		}

		if (document.querySelector('.site-farlo-ui-crm')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-crm__toggle')) {
			document
				.querySelectorAll('.site-farlo-ui-crm__toggle')
				.forEach((_sel) => {
					_sel.addEventListener('click', (e) => {
						e.preventDefault();
						e.stopImmediatePropagation();
						farloUiCrmSignup(e);
					});
				});
		}

		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document
				.querySelectorAll('[farlo-ui="calendar"]')
				.forEach((_sel) => {
					new FarloUiTicketCalendar(_sel);
				});
		}

		if (document.querySelector('.site-farlo-ui-masthead-carousel')) {
			document
				.querySelectorAll('[farlo-ui="masthead-carousel')
				.forEach((_sel) => {
					new FarloUiMastheadCarousel(_sel);
				});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document
				.querySelectorAll('[farlo-ui="flickity-carousel"]')
				.forEach((_sel) => {
					new FarloUiRevolverFlickityCarousel(_sel);
				});
		}


		if (document.querySelector('.wp-block-embed')) {
			document.querySelectorAll('.wp-block-embed__wrapper').forEach(function(_sel) {
			  const embedDiv = document.createElement('div');
	
			  if (!(_sel.querySelector('.wp-block-embed__player'))) {
					embedDiv.className = 'wp-block-embed__player';
					_sel.append(embedDiv);
	
					embedDiv.addEventListener('click', (e) => {
				  const iframe = e.currentTarget.parentNode.querySelector('iframe');
				  const dataSrc = iframe.getAttribute('data-src');
	
				  e.currentTarget.parentNode.classList.toggle('wp-block-embed__wrapper--is-playing');
	
				  if (dataSrc) {
							iframe.setAttribute('src', dataSrc + '&autoplay=1&playsinline=1&muted=1');
				  } else {
							const src = iframe.getAttribute('src');
							iframe.setAttribute('src', src + '&autoplay=1&playsinline=1&muted=1');
				  }
					});
			  }
			});
		  }

		if (document.querySelector('form')) {
			document
				.querySelector('form')
				.querySelectorAll('select')
				.forEach((_sel) => {
					new FarloUiSelectBox(_sel);
				});
		}

		if (document.querySelector('.site-colour-block__ornament')) {
			document
				.querySelectorAll('.site-colour-block__ornament')
				.forEach((_sel) => {
					elementInView(_sel);
				});
		}

		if (document.querySelector('.site-farlo-ui-lightbox__toggle')) {
			document
				.querySelectorAll('.site-farlo-ui-lightbox__toggle')
				.forEach((_sel) => {
					new FarloUiLightbox(_sel);
				});
		}

		if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
			document
				.querySelectorAll('[farlo-ui="carousel"]')
				.forEach((_sel) => {
					new FarloUiRevolverCarousel(_sel);
				});
		}

		if (document.querySelector('.gform_wrapper')) {
			document
				.querySelector('.gform_wrapper')
				.querySelectorAll('[placeholder]')
				.forEach((_sel) => {
					formLabels(_sel);
				});

			document.querySelectorAll('.gform_wrapper').forEach((_sel) => {
				formSubmitButtons(_sel);
			});
		}

		if (document.getElementById('site-google-translate')) {
			document
				.getElementById('site-google-translate')
				.querySelectorAll('select')
				.forEach((_sel) => {
					setTimeout(() => {
						new FarloUiSelectBox(_sel);
					}, 600);
				});
		}
	});

	window.addEventListener('load', () => {
		document.body.classList.add('loaded');

		if (document.getElementById('site-google-translate')) {
			document
				.getElementById('site-google-translate')
				.querySelectorAll('select')
				.forEach((_sel) => {
					setTimeout(() => {
						new FarloUiSelectBox(_sel);
					}, 600);
				});
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker
			.getRegistrations()
			.then(function (registrations) {
				for (const registration of registrations) {
					registration.unregister();
				}
			});
	}
})(document, window, history);
